module.exports = __webpack_public_path__ + "static/media/ico_contratar_new.78b39cf6.svg";